import { store } from "../store";

// import firebase from 'firebase'

export default (to, from, next) => {
  // const duid = firebase.auth().currentUser.uid
  // console.log(duid)

  if (store.getters.factsuser && store.getters.fbuserdata.usertype == 1 /*|| from*/) {
    next();
  } else {
    next("/");
  }
  store.dispatch("getScreenName", {
    screenName: to.name,
  });
};
